import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getData } from "../../services/dataService.jsx";
import "../../assets/styles/bootstrap.css";
import ListGroup from "react-bootstrap/ListGroup";
import axios from "../../api/axios"
import Card from "react-bootstrap/Card";
import Carousel from "react-bootstrap/Carousel";
import { useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Badge from "react-bootstrap/Badge";
import Alert from 'react-bootstrap/Alert';
import DepartedForm from "../../components/departed/DepartedForm.jsx";
import GraveForm from "../../components/grave/GraveForm.jsx";
import DeleteModal from "../../components/DeleteModal.jsx";
import CoordinatesMap from "../../components/CoordinatesMap";
import { CardBody } from "react-bootstrap";
import ListContainer from "../../components/containers/ListContainer";
import Button from "react-bootstrap/Button";

function GraveDetails() {
  const { t, i18n } = useTranslation();
  const [grave, setGrave] = useState([]);
  const [graveID, setGraveID] = useState("");
  const [departedID, setDepartedID] = useState("");
  const [ID, setID] = useState("");
  const [identifier, setIdentifier] = useState("");
  const [showDepartedForm, setShowDepartedForm] = useState(false);
  const [showGraveForm, setShowGraveForm] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [departedFormType, setDepartedFormType] = useState("create");
  const [deleteModalType, setDeleteModalType] = useState("grave");
  const [updateSuccesful, setUpdateSuccesful] = useState(false);
  const [deleteSuccesful, setDeleteSuccesful] = useState(false);

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileDescriptions, setFileDescriptions] = useState({});
  const [uploadError, setUploadError] = useState("");
  const [uploadSuccess, setUploadSuccess] = useState("");
  const [showImg, setShowImg] = useState([]);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    const getGrave = async () => {
      try {
        setLoading(true);
        const data = await getData(`/graves/${location.state.uuid}`);
        setGrave(data);
      } catch (error) {
        console.log("Error fetching data: ", error.message);
      } finally {
        setLoading(false);
      }
    };
    getGrave();
    setUpdateSuccesful(false);
    setDeleteSuccesful(false);
    // eslint-disable-next-line
  }, [updateSuccesful, deleteSuccesful]);

  const handleShowDepartedForm = (graveID, departedID, formType) => {
    setGraveID(graveID);
    setDepartedID(departedID);
    setDepartedFormType(formType);
    setShowDepartedForm(true);
  };

  const handleCloseDepartedForm = (isSuccesful) => {
    setShowDepartedForm(false);
    if (isSuccesful) {
      setUpdateSuccesful(true);
    }
  };

  const handleShowGraveForm = (graveID) => {
    setGraveID(graveID);
    setShowGraveForm(true);
  };

  const handleCloseGraveForm = (isSuccesful) => {
    setShowGraveForm(false);
    if (isSuccesful) {
      setUpdateSuccesful(true);
    }
  };
  const handleShowDeleteModal = (id, identifier, deleteType) => {
    setID(id);
    setIdentifier(identifier);
    setDeleteModalType(deleteType);
    setShowDeleteModal(true);
  };


  const handleCloseDeleteModal = (deleteType) => {
    setShowDeleteModal(false);
    if (deleteType === "grave") {
      navigate("/graves");
      setDeleteSuccesful(true);
    } else if (deleteType === "departed") {
      setDeleteSuccesful(true);
    }
  };

  useEffect(() => {
 }, [grave?.coordinate?.x, grave?.coordinate?.y, grave]);

useEffect(() => {
    if (!grave?.imageList) {
        return;
    }
    const fetchImages = async () => {
        const imagePromises = grave?.imageList.map(async (img) => {
            try {
                const resp = await axios.get(`/images/path/${encodeURIComponent(img.path)}`, { responseType: "blob" });
                return { url: URL.createObjectURL(resp.data), id: img.path };
            } catch (error) {
                console.error("Error fetching image: ", error.message);
                return null;
            }
        });

        const images = await Promise.all(imagePromises);
        const validImages = images.filter(image => image !== null);
        setShowImg(validImages);
    };
    fetchImages();
}, [grave]);



  const romeNumbersArray = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];
  const arabToRomeNumber = (number) => {
    return romeNumbersArray[number - 1];
  }

  const renderDates = (departed) => {
    return (<>
      {
        (departed?.bornYear) && (
          (departed?.bornMonth && departed?.bornDay) ?
            ((i18n.language === "en") ?
              (<ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("born")}</span>
                {`: ${departed?.bornMonth}-${departed?.bornDay}-${departed?.bornYear} `}
              </ListGroup.Item>) :
              (<ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("born")}</span>
                {`: ${departed?.bornYear}. ${arabToRomeNumber(departed?.bornMonth)}. ${departed?.bornDay}. `}
              </ListGroup.Item>)) :
            (<>
              {(departed?.bornYear) && <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("bornYear")}</span>
                {`: ${departed.bornYear} `}
              </ListGroup.Item>}
              {(departed?.bornMonth) && <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("bornMonth")}</span>
                {`: ${departed.bornMonth} `}
              </ListGroup.Item>}
              {(departed?.bornDay) && <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("bornDay")}</span>
                {`: ${departed.bornDay} `}
              </ListGroup.Item>}
            </>)
        )
      }
      {
        (departed?.deathYear) && (
          (departed?.deathMonth && departed?.deathDay) ?
            ((i18n.language === "en") ?
              (<ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("death")}</span>
                {`: ${departed?.deathMonth}-${departed?.deathDay}-${departed?.deathYear}`}
              </ListGroup.Item>) :
              (<ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("death")}</span>
                {`: ${departed?.deathYear}. ${arabToRomeNumber(departed?.deathMonth)}. ${departed?.deathDay}.`}
              </ListGroup.Item>)) :
            (<>
              {(departed?.deathYear) && <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("deathYear")}</span>
                {`: ${departed.deathYear} `}
              </ListGroup.Item>}
              {(departed?.deathMonth) && <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("deathMonth")}</span>
                {`: ${departed.deathMonth} `}
              </ListGroup.Item>}
              {(departed?.deathDay) && <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("deathDay")}</span>
                {`: ${departed.deathDay} `}
              </ListGroup.Item>}
            </>)
        )
      }
    </>)
  }
  const handleShowUploadModal = () => setShowUploadModal(true);
    const handleCloseUploadModal = () => {
      setShowUploadModal(false);
      setSelectedFiles([]);
      setFileDescriptions({});
      setUploadError("");
      setUploadSuccess("");
    };

    const handleFileChangeUpload = (event) => {
      setSelectedFiles(event.target.files);
      setFileDescriptions({});
      setUploadError("");
      setUploadSuccess("");
    };

    const handleDescriptionChangeUpload = (event, fileName) => {
      const { value } = event.target;
      setFileDescriptions((prev) => ({
        ...prev,
        [fileName]: value,
      }));
    };

    const handleUploadImages = async () => {
      if (selectedFiles.length === 0) {
        setUploadError(t("noFilesSelected") + "❌");
        return;
      }

      try {
       setLoading(true);
       let successMessages = "";
       for (let i = 0; i < selectedFiles.length; i++) {
                      const formData = new FormData();
                      formData.append("name", fileDescriptions[selectedFiles[i].name] || "");
                      formData.append("fileName", selectedFiles[i].name);
                      formData.append("file", selectedFiles[i]);
                      formData.append("graveID", location.state.uuid);

                      const response = await axiosPrivate.post("/images", formData, {
                          headers: {
                              "Content-Type": "multipart/form-data",
                          },
                      });

                      if (response.status === 200) {
            successMessages = `${t("uploadSuccess")}\n`;
            successMessages += "✅";
                      }
                  }
                  setSelectedFiles([]);
        setUploadSuccess(successMessages);
        setSelectedFiles([]);
        setFileDescriptions({});
      } catch (error) {
        if (!error.response) {
          setUploadError(t("noServerResponse"));
        } else if (error.response.status === 400) {
          setUploadError(t("Error"));
        } else {
          setUploadError(t("Error"));
        }
      }
      setLoading(false);
      setUpdateSuccesful(true);
    };

  return (
    <>
      <ListContainer>
        <Card className="card-component">
          <div className="d-flex justify-content-end">
            <Badge
              className="action-btn p-2 my-2"
              style={{
                width: "43px",
                height: "43px",
                fontSize: "x-large",
                justifyContent: "center",
                alignContent: "center"
              }}
              bg="secondary"
              onClick={() => handleShowDepartedForm(grave.uuid, "", "create")}
            >
              <i className="bi bi-plus-circle"></i>
            </Badge>
            <Badge
              className="action-btn p-2 m-2"
              style={{
                width: "43px",
                height: "43px",
                fontSize: "x-large",
                justifyContent: "center",
                alignContent: "center"
              }}
              bg="secondary"
              onClick={() => handleShowGraveForm(grave.uuid)}
            >
              <i className="bi bi-pencil"></i>
            </Badge>
            <Badge
              className="action-btn p-2 my-2"
              style={{
                width: "43px",
                height: "43px",
                fontSize: "x-large",
                justifyContent: "center",
                alignContent: "center"
              }}
              bg="secondary"
              onClick={() =>
                handleShowDeleteModal(grave.uuid, grave.identifier, "grave")
              }
            >
              <i className="bi bi-trash"></i>
            </Badge>
            <Badge
                          className="action-btn p-2 my-2"
                          style={{
                            width: "43px",
                            height: "43px",
                            fontSize: "x-large",
                            justifyContent: "center",
                            alignContent: "center",
                            marginLeft: "8px"
                          }}
                          bg="secondary"
                          onClick={handleShowUploadModal}

                        >
                          <i className="bi bi-box-arrow-up"></i>
             </Badge>
          </div>
          <Carousel data-bs-theme="dark">
          {loading ? (
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
               ) : (
              showImg.map((img, index) => (
                <Carousel.Item key={img?.id || index}>
                  <img
                    className="d-block w-100"
                    src={img?.url}
                    alt={img?.id}
                    width="500"
                    height="345"
                    onLoad={() => setLoading(false)} // Hide spinner when image is loaded
                  />
                   </Carousel.Item>
                 ))
                 )}
          </Carousel>
          <Card.Body>
            <Card.Title>
              {grave?.identifier + " " + grave?.graveType?.typeName}
            </Card.Title>
          </Card.Body>
          <ListGroup className="list-group-flush">
            <ListGroup.Item>
              <span style={{ fontWeight: "bold" }}>{t("parcelNumber")}</span>:{" "}
              {grave?.identifier}
            </ListGroup.Item>
            <ListGroup.Item>
              <span style={{ fontWeight: "bold" }}>{t("graveType")}</span>:{" "}
              {grave?.graveType?.typeName}
            </ListGroup.Item>
            <ListGroup.Item>
              <span style={{ fontWeight: "bold" }}>{t("century")}</span>:{" "}
              {grave?.century?.century}
            </ListGroup.Item>
            <ListGroup.Item>
              <span style={{ fontWeight: "bold" }}>{t("graveMaker")}</span>:{" "}
              {grave?.graveMaker?.name}
            </ListGroup.Item>
          </ListGroup>
          <Card.Body>
            <Card.Text>{grave?.description}</Card.Text>
          </Card.Body>
          {grave?.coordinate && !!grave?.coordinate?.x && (
            <Card className="m-3 card-component">
              <CardBody>
                <CoordinatesMap
                  lat={grave?.coordinate?.x}
                  lng={grave?.coordinate?.y}
                  isMarkerDraggable={false}
                  style={{ width: "500px", height: "400px" }}
                />
              </CardBody>
            </Card>
          )}
          <Card className="m-2 card-component">
            <Card.Header as="h5">
              <span style={{ fontWeight: "bold" }}>{t("rests here")}</span>
            </Card.Header>
            {grave?.departedList?.map((departed, index) => {
              return (
                <Card.Body key={departed.uuid}>
                  <Card.Title>
                    <div className="d-flex justify-content-end">
                      <Badge
                        className="action-btn p-2 mx-2"
                        style={{
                          width: "43px",
                          height: "43px",
                          fontSize: "x-large",
                          justifyContent: "center",
                          alignContent: "center"
                        }}
                        bg="secondary"
                        onClick={() =>
                          handleShowDepartedForm(
                            grave.uuid,
                            departed.uuid,
                            "update"
                          )
                        }
                      >
                        <i className="bi bi-pen"></i>
                      </Badge>
                      <Badge
                        className="action-btn p-2"
                        style={{
                          width: "43px",
                          height: "43px",
                          fontSize: "x-large",
                          justifyContent: "center",
                          alignContent: "center"
                        }}
                        bg="secondary"
                        onClick={() =>
                          handleShowDeleteModal(
                            departed.uuid,
                            departed.familyName + " " + departed.givenName,
                            "departed"
                          )
                        }
                      >
                        <i className="bi bi-person-dash"></i>
                      </Badge>
                    </div>
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                    {" "}
                    {departed?.namePrefix && ` ${departed.namePrefix} `}
                    {departed?.familyName && ` ${departed.familyName} `}
                    {departed?.bornFamilyName && (
                      <span style={{ fontWeight: "normal" }}>
                      {"(" + departed.bornFamilyName + ")"}{" "}
                    </span>
                    )}
                    {departed?.givenName && ` ${departed.givenName} `}
                  </Card.Subtitle>
                  <ListGroup className="list-group-flush">
                    {departed?.familyName && (
                      <ListGroup.Item>
                      <span style={{ fontWeight: "bold" }}>
                        {t("familyName")}
                      </span>
                        {`: ${departed.familyName} `}
                      </ListGroup.Item>
                    )}
                    {departed?.bornFamilyName && (
                      <ListGroup.Item>
                      <span style={{ fontWeight: "bold" }}>
                        {t("bornFamilyName")}
                      </span>
                        {`: ${departed.bornFamilyName} `}
                      </ListGroup.Item>
                    )}
                    {departed?.givenName && (
                      <ListGroup.Item>
                      <span style={{ fontWeight: "bold" }}>
                        {t("givenName")}
                      </span>
                        {`: ${departed.givenName} `}
                      </ListGroup.Item>
                    )}
                    {renderDates(departed)}
                    {departed?.birthPlace?.placeName && (
                      <ListGroup.Item>
                      <span style={{ fontWeight: "bold" }}>
                        {t("birthPlace")}
                      </span>
                        {`: ${departed.birthPlace?.placeName} `}
                      </ListGroup.Item>
                    )}
                    {departed?.deathPlace?.placeName && (
                      <ListGroup.Item>
                      <span style={{ fontWeight: "bold" }}>
                        {t("deathPlace")}
                      </span>
                        {`: ${departed.deathPlace?.placeName} `}
                      </ListGroup.Item>
                    )}
                    {departed?.occupation?.occupationName && (
                      <ListGroup.Item>
                      <span style={{ fontWeight: "bold" }}>
                        {t("occupation")}
                      </span>
                        {`: ${departed?.occupation?.occupationName} `}
                      </ListGroup.Item>
                    )}
                    {departed?.heroism && (
                      <ListGroup.Item>
                        <span style={{ fontWeight: "bold" }}>{t("heroism")}</span>
                        {`: ${departed.heroism} `}
                      </ListGroup.Item>
                    )}
                  </ListGroup>
                  <Card.Text>
                    {departed?.description && ` ${departed.description} `}
                  </Card.Text>
                </Card.Body>
              );
            })}
          </Card>
        </Card>
      </ListContainer>
      <DepartedForm
        show={showDepartedForm}
        onClose={handleCloseDepartedForm}
        graveID={graveID}
        departedID={departedID}
        formType={departedFormType}
      />
      <GraveForm
        show={showGraveForm}
        onClose={handleCloseGraveForm}
        graveID={graveID}
        formType={"update"}
      />
      <DeleteModal
        show={showDeleteModal}
        onClose={handleCloseDeleteModal}
        ID={ID}
        identifier={identifier}
        deleteType={deleteModalType}
      />
      <Modal show={showUploadModal} onHide={handleCloseUploadModal} size="lg" centered>
            <Modal.Header closeButton>
              <Modal.Title>{t("uploadImages")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group controlId="formFileMultiple" className="mb-3">
                  <Form.Label>{t("")}</Form.Label>
                  <Form.Control type="file" multiple onChange={handleFileChangeUpload}  />
                </Form.Group>
                {selectedFiles.length > 0 && (
                  <ListGroup className="mb-3">
                    {Array.from(selectedFiles).map((file, index) => (
                      <ListGroup.Item key={index}>
                        <strong>{file.name}</strong>
                        <Form.Control
                          type="text"
                          placeholder={t("enterDescription")}
                          value={fileDescriptions[file.name] || ""}
                          onChange={(e) => handleDescriptionChangeUpload(e, file.name)}
                          className="mt-2"
                        />
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                )}
                {uploadError && (
                 <Alert key="danger" variant="danger">
                            {uploadError}
                  </Alert>
                )}
                {uploadSuccess && (
                    <Alert key="success" variant="success">
                            {uploadSuccess}
                       </Alert>
                )}
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseUploadModal}>
                {t("close")}
              </Button>
              <Button variant="primary" onClick={handleUploadImages} disabled={selectedFiles.length === 0}>
                {t("upload")}
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      );
}

export default GraveDetails;
